import { render, staticRenderFns } from "./reposition.vue?vue&type=template&id=6c3bb05c&scoped=true"
import script from "./reposition.vue?vue&type=script&lang=js"
export * from "./reposition.vue?vue&type=script&lang=js"
import style0 from "./reposition.vue?vue&type=style&index=0&id=6c3bb05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3bb05c",
  null
  
)

export default component.exports